'use strict';

angular.module('shiftTraderApp')
  .controller('DaysOffContentCalendarListCtrl', function($scope, AvailabilityRules, TimeService, $state, $stateParams, $location,
                                         SAErrorHandler, $timeout, me, daysOff, org, $rootScope, toastr,
                                         Session, allMinUsers, $interval, DaysOffUserStatsService, WorkPeriods,
                                         DaysOffRouteSyncService, DaysOffStore, UserPermissionsService) {
    $scope.me = me;
    $scope.org = org;

    $scope.allDepartments = _.map($scope.org.departments, function(dept) {
      dept._selected = true;
      return dept;
    });

    $scope.allMinUsers = _.sortBy(_.map(_.where(allMinUsers, function(u) {
      return u.$curMemb().active === 1;
    }), function(u) {
      u._filteredDayOffCount = 0;
      return u;
    }), 'first_name');

    $scope.nowDate = TimeService.getNowInStoreTime();
    $scope.currentDate = TimeService.getBeginningOfDayFromDate(moment.utc($stateParams.date)).startOf('month');
    $scope.workDayStartHour = Session.getWorkDayStartHour();

    $scope.commForm = {
      message: ''
    };

    $scope.state = {
      communicationDrawerOpen: false,
      selectedDepartments: _.cloneDeep($scope.org.departments),
      focusedOnUser: !_.isNull($stateParams.userId) && $stateParams.userId !== NaN && $stateParams.userId !== undefined && $stateParams.userId !== '',
      selectedStatuses: {
        approved: true,
        pending: true,
        disapproved: true
      },
      workPeriodsReturned: false,
      rawPermissions: null,
      derivedPermissions: null
    };

    var permissionsToLookUp = [
      'days_off.add_message',
      'work_periods.view_in_org'
    ];

    function processRawPermissions() {
      var rawPerms = $scope.state.rawPermissions;

      $scope.state.derivedPermissions = {
        canSendMessageInOrg: rawPerms['days_off.add_message'],
        canLoadOtherWorkPeriods: rawPerms['work_periods.view_in_org']
      };

      setPlaceholderText();
    }

    UserPermissionsService.getCanDict(permissionsToLookUp, $scope.org.id)
      .then(function(dikt) {
        $scope.state.rawPermissions = dikt;

        processRawPermissions();
        callFocusOnDayOff()
      });

    $scope.state.relevantUserId = $scope.state.focusedOnUser ? parseInt($stateParams.userId) : '';

    $scope.clearEmployeeSelection = function() {
      $scope.state.relevantUserId = undefined;
    };

    $scope.toggleCommunicationDrawer = function() {
      $scope.state.communicationDrawerOpen = !$scope.state.communicationDrawerOpen;
    };

    var firstWeek = TimeService.getWeekTwixFromMoment($scope.currentDate);

    $scope.weeks = _.map([0,1,2,3,4,5], function(x) {
      return (moment(firstWeek.start).add(x, 'weeks')).twix(moment(firstWeek.start).add(x+1, 'weeks'));
    });

    //clip it down to the last week that has a day in the current month
    _.each([5,4], function(x) {
      if (!$scope.weeks[1].start.isSame($scope.weeks[x].start, 'month')) {
        $scope.weeks.splice(x,1);
      }
    });
    var currentViewDateRange = $scope.weeks[0].start.twix($scope.weeks[$scope.weeks.length-1].end);

    $rootScope.$on('daysOff:filterChange', function() {
      var filters = DaysOffRouteSyncService.getFilters();

      $scope.state.selectedDepartments = _.where($scope.allDepartments, function(dept) {
        return _.contains(filters.departmentIds, dept.id);
      });

      calculateDaysOffDataStructure();
    });


    var setDayOffProperties = function(dayOff) {
      dayOff._cssClasses = {};
      if (dayOff.$isApproved()) {
        dayOff._cssClasses.approved = true;
      } else if (dayOff.$isDisapproved()) {
        dayOff._cssClasses.disapproved = true;
      } else if (dayOff.$isPending() && !dayOff.$isExpired()) {
        dayOff._cssClasses.pending = true;
      } else if (dayOff.$isPending() && dayOff.$isExpired()) {
        dayOff._cssClasses.expired = true;
      }
      return dayOff;
    };

    $scope.allDaysOff = _.map(_.where(daysOff, function(dayOff) {
      return currentViewDateRange.overlaps(dayOff.range_twix) &&
        Math.abs(currentViewDateRange.intersection(dayOff.range_twix).length('minutes')) > 0;
    }), function(dayOff) {
      return setDayOffProperties(dayOff);
    });

    $scope.datesByWeek = _.map($scope.weeks, function(week) {
      return _.map(_.range(7), function(dayNum) {
        return moment(week.start).add(dayNum, 'days').twix(moment(week.start).add(dayNum + 1, 'days'));
      });
    });

    var calculateDaysOffDataStructure = function () {
      var departmentIdsToShow = _.pluck($scope.state.selectedDepartments, 'id');
      $scope.filteredDaysOff = _.where($scope.allDaysOff, function(dor) {
        var hasDeptMetadata = dor.user.metadata && dor.user.metadata.department_ids_by_org &&
          dor.user.metadata.department_ids_by_org.data && dor.user.metadata.department_ids_by_org.data[dor.organization_id]
          && dor.user.metadata.department_ids_by_org.data[dor.organization_id].length > 0;

        return !hasDeptMetadata || _.any(departmentIdsToShow, function(idToShow) {
            return _.contains(dor.user.metadata.department_ids_by_org.data[dor.organization_id], idToShow);
          });
      });

      var daysOffWithoutEmployeeFilter = [];
      if ($scope.state.selectedStatuses.approved) {
        daysOffWithoutEmployeeFilter.push(_.where($scope.filteredDaysOff, function(dayOff) {
          return dayOff.$isApproved();
        }));
      }

      if ($scope.state.selectedStatuses.pending) {
        daysOffWithoutEmployeeFilter.push(_.where($scope.filteredDaysOff, function(dayOff) {
          return dayOff.$isPending();
        }));
      }

      if ($scope.state.selectedStatuses.disapproved) {
        daysOffWithoutEmployeeFilter.push(_.where($scope.filteredDaysOff, function(dayOff) {
          return dayOff.$isDisapproved();
        }));
      }
      daysOffWithoutEmployeeFilter = _.flatten(daysOffWithoutEmployeeFilter);

      $scope.allMinUsers = _.map($scope.allMinUsers, function(u) {
        u._filteredDayOffCount = 0;
        return u;
      });

      _.each(daysOffWithoutEmployeeFilter, function(dayOff) {
        var idx = _.findIndex($scope.allMinUsers, {id: dayOff.user.id});
        if (idx > -1) {
          $scope.allMinUsers[idx]._filteredDayOffCount += 1;
        }
      });

      $scope.focusableUsers = _.where($scope.allMinUsers, function(u) {
        return u._filteredDayOffCount > 0;
      });

      if (!_.contains(_.pluck($scope.focusableUsers, 'id'), $scope.state.relevantUserId)) {
        $scope.clearEmployeeSelection();
      }

      $scope.daysOffByWeek = _.map($scope.datesByWeek, function (weekOfDays, idx) {
        return {
          week: $scope.weeks[idx],
          days: _.map(weekOfDays, function (dt) {
            var temp = {
              range_twix: dt,
              _cssClasses: {
                previous_month: dt.start.isBefore($scope.currentDate),
                next_month: dt.start.isAfter(moment($scope.currentDate).endOf('month'))
              },
              items: _.map(_.where($scope.filteredDaysOff, function (dayOff) {
                return dayOff.range_twix.overlaps(dt) &&
                  Math.abs(dayOff.range_twix.intersection(dt).length('minutes')) > 0 &&
                  dayOff.range_twix.end.isAfter(moment(dt.start).add($scope.workDayStartHour, 'hours'), 'minute') &&
                  ( ($scope.state.selectedStatuses.approved && dayOff.$isApproved()) ||
                  ($scope.state.selectedStatuses.pending && dayOff.$isPending()) ||
                  ($scope.state.selectedStatuses.disapproved && dayOff.$isDisapproved()) );
              }), function(dayOff) {

                // set if an item should show continued or not
                var clone = _.cloneDeep(dayOff);

                // continues is true if this dayOff end goes past end of day
                clone._cssClasses.continues = dayOff.range_twix.end.isAfter(dt.end);
                clone._cssClasses.from_last = dayOff.range_twix.start.isBefore(dt.start);
                clone._cssClasses.is_relevant_user = $scope.state.focusedOnUser && parseInt($scope.state.relevantUserId) === dayOff.user_id;
                clone._cssClasses.not_relevant_user = $scope.state.focusedOnUser && !clone._cssClasses.is_relevant_user;
                if ($scope.focusedOn) {
                  clone._cssClasses.selected = $scope.focusedOn.id === dayOff.id;
                }

                return clone;
              })
            };

            temp._expanded = $scope.focusedOn && _.any(temp.items, {id: $scope.focusedOn.id}) && temp.items.length > 3;

            return temp;
          })
        };
      });
    };


    $scope.focusOnDayOff = function(item) {
      $scope.state.communicationDrawerOpen = false;
      var userIdString = '';
      if ($scope.state.focusedOnUser) {
        userIdString += '?userId=' + $scope.state.relevantUserId;
      }

      if (!_.isUndefined($scope.focusedOn)) {
        $scope.focusedOn.daysOffStats = undefined;
        $scope.focusedOn.overlappingWorkPeriods = [];
      }

      if (!_.isUndefined(item)) {
        var idx = _.findIndex($scope.allDaysOff, {id: item.id});
        if (idx > -1) {
          $scope.focusedOn = $scope.allDaysOff[idx];
          $scope.availabilityStartDate = moment.utc().startOf('day').subtract(6, 'months').startOf('month');
          $scope.focusedOn.daysOffStats = DaysOffUserStatsService.initializeInstance();
          $scope.focusedOn.daysOffStats.init($scope.focusedOn.user, $scope.availabilityStartDate, false, true);


          if ($scope.state.derivedPermissions.canLoadOtherWorkPeriods || $scope.me.id === $scope.focusedOn.user.id) {
            $scope.state.workPeriodsReturned = false;
            WorkPeriods.getByUserId($scope.focusedOn.user.id, {
              start_time: moment($scope.focusedOn.start).subtract(1, 'days').format(),
              end_time: moment($scope.focusedOn.end).add(1, 'days').format(),
              published: true
            }).then(function(workPeriods) {
              $scope.focusedOn.overlappingWorkPeriods = _.where(workPeriods, function(wp) {
                return wp.range_twix.overlaps($scope.focusedOn.range_twix) &&
                  Math.abs(wp.range_twix.intersection($scope.focusedOn.range_twix).length('minutes')) > 0;
              });
              $scope.state.workPeriodsReturned = true;
            }, function(response) {
              console.log('couldnt load WorkPeriods');
            });
          }


          $scope.focusAreaOpen = true;
          if (parseInt($stateParams.id) !== item.id) {
            $location.url('/daysOff/' + moment($scope.currentDate).startOf('month').format('YYYY-MM-DD') + '/calendarList/' + item.id + userIdString);
          }
        } else {
          $scope.focusAreaOpen = false;
          $scope.focusedOn = undefined;
          if ($stateParams.id) {
            if ($scope.state.focusedOnUser) {
              $state.go('daysOff.intermediate.date.calendarList', {date: moment($scope.currentDate).startOf('month').format('YYYY-MM-DD'), userId: $scope.state.relevantUserId}, {notify: false, location: true, inherit: false});
            } else {
              $state.go('daysOff.intermediate.date.calendarList', {date: moment($scope.currentDate).startOf('month').format('YYYY-MM-DD')}, {notify: false, location: true, inherit: false});
            }
          }
        }
      } else {
        $scope.focusAreaOpen = false;
        $scope.focusedOn = undefined;
        $location.url('/daysOff/' + moment($scope.currentDate).startOf('month').format('YYYY-MM-DD') + '/calendarList' + userIdString);
      }

      calculateDaysOffDataStructure();
    };


    function callFocusOnDayOff() {
      if ($stateParams.id) {
        var idx = _.findIndex($scope.allDaysOff, {id: parseInt($stateParams.id)});
        if (idx > -1) {
          $scope.focusOnDayOff($scope.allDaysOff[idx]);
        } else {
          $scope.focusOnDayOff();
        }
      }
    }


    calculateDaysOffDataStructure();

    $scope.$watch('state.selectedStatuses', function() {
      calculateDaysOffDataStructure();
    }, true);


    var lastHeight, newHeight;
    var resizeInterval = $interval(function() {
      newHeight = $('.days_off_focus_area').outerHeight(true);
      if (lastHeight !== newHeight) {
        $('.days_off_calendar_area_placeholder').css('height', newHeight);

        $('.days_off_calendar_area').css('height', 475 - newHeight);
      }
    }, 100);

    $rootScope.$on('$locationChangeSuccess', function (e, newUrl, oldUrl) {
      if (!_.contains(newUrl, 'calendarList')) {
        $interval.cancel(resizeInterval);

        $('.days_off_calendar_area_placeholder').css('height', undefined);

        $('.days_off_calendar_area').css('height', undefined);
      }
    });

    $scope.goBackMonth = function() {
      $state.go('daysOff.intermediate.date', {
        date: moment($scope.currentDate).subtract(5, 'days').startOf('month').format('YYYY-MM-DD'),
        userId: $scope.state.relevantUserId
      });
    };

    $scope.advanceMonth = function() {
      $state.go('daysOff.intermediate.date', { date: moment($scope.currentDate).add(35, 'days').startOf('month').format('YYYY-MM-DD'),
        userId: $scope.state.relevantUserId
      });
    };


    $scope.approveDayOffRequest = function(dayOff) {
      dayOff.$approve()
        .then(function() {
          DaysOffStore.addOrReplaceRecord(dayOff);

          dayOff = setDayOffProperties(dayOff);
          calculateDaysOffDataStructure();
          toastr.success(dayOff.$minimalIntervalTimeFormat() + ' Approved!', 'Success');
        }, function(response) {
          console.log('approveBlackoutDate had an error');
          console.log(response);
          SAErrorHandler.processError(response);
        });
    };

    $scope.disapproveDayOffRequest = function(dayOff) {
      dayOff.$disapprove()
        .then(function() {
          DaysOffStore.addOrReplaceRecord(dayOff);

          dayOff = setDayOffProperties(dayOff);
          calculateDaysOffDataStructure();
          toastr.success(dayOff.$minimalIntervalTimeFormat() + ' Disapproved!', 'Success');
        }, function(response) {
          console.log('disapproveBlackoutDate had an error');
          console.log(response);
          SAErrorHandler.processError(response);
        });
    };

    $scope.cancelDayOffRequest = function(dayOff) {
      dayOff.$makeInactive()
        .then(function() {
          $scope.focusOnDayOff();
          DaysOffStore.addOrReplaceRecord(dayOff);
          toastr.success(dayOff.$minimalIntervalTimeFormat() + ' Cancelled!', 'Success');
        }, function() {
          toastr.error('There was a problem cancelling your day off request. Please try again later', 'Error');
        });
    };

    $scope.sendMessage = function() {
      if ($scope.state.derivedPermissions.canSendMessageInOrg || $scope.me === $scope.focusedOn.user.id) {
        $scope.focusedOn.$sendMessage($scope.commForm.message, $scope.me)
          .then(function() {
            $scope.commForm.message = '';
            DaysOffStore.addOrReplaceRecord($scope.focusedOn);

            toastr.success('Message sent for day off request!', 'Success');
            $timeout(function() {
              $('.day_off_messages_container').animate({
                scrollTop: $('.day_off_messages_container')[0].scrollHeight
              }, 300);
            }, 300);
          }, function(response) {
            console.log('sendMessage had an error');
            console.log(response);
            SAErrorHandler.processError(response);
          });
      }
    };


    function setPlaceholderText() {
      if ($scope.focusedOn && $scope.me.id === $scope.focusedOn.user.id) {
        $scope.placeholderText = 'Reply to your day off request.';
      } else if ($scope.state.derivedPermissions && $scope.state.derivedPermissions.canSendMessageInOrg && $scope.focusedOn && $scope.me.id !== $scope.focusedOn.user.id) {
        $scope.placeholderText = 'Ask a question or provide explanation for your decision.';
      }
    }

  });
